import React, { useEffect, useState } from 'react';

const socialLinks = [
  { name: 'GitHub', url: 'https://github.com/pavithra2870', icon: '🐙' },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/pavithra-k-r-9b2a84314/', icon: '💼' },
  { name: 'LeetCode', url: 'https://leetcode.com/u/pavithrakr28/', icon: '🧩' },
  { name: 'Kaggle', url: 'https://www.kaggle.com/pavithrakr28', icon: '📊' },
  { name: 'CodeChef', url: 'https://www.codechef.com/users/pavithrakrvitc', icon: '🍳' },
  { name: 'Mail', url: 'mailto:pavithra6mail@gmail.com', icon: '✉️' },
];

const TYPING_TEXT = "Hello, I'm Pavithra";

const Hero = () => {
  const [typed, setTyped] = useState('');
  useEffect(() => {
    let i = 0;
    setTyped('');
    const interval = setInterval(() => {
      setTyped(TYPING_TEXT.slice(0, i + 1));
      i++;
      if (i === TYPING_TEXT.length) clearInterval(interval);
    }, 80);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="min-h-screen flex items-center justify-center relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(rgba(0, 212, 255, 0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 212, 255, 0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }} />
      </div>

      <div className="max-w-2xl mx-auto px-4 text-center relative z-10">
        <h1 className="text-5xl md:text-6xl font-bold text-blue-400 mb-4">
          <span className="inline-block border-r-2 border-blue-400 pr-1 animate-blink">{typed}</span>
        </h1>
        <div className="text-xl md:text-2xl text-green-400 mb-2">Full-Stack Developer</div>
        <p className="text-lg text-gray-300 mb-6">
          B.Tech CSE | MERN | AI/ML | Problem Solver
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 bg-gray-800 text-white rounded-lg transition transform hover:scale-105 hover:bg-blue-500 hover:underline"
              title={link.name}
            >
              <span className="text-2xl">{link.icon}</span>
              <span className="hidden sm:inline text-base font-medium">{link.name}</span>
            </a>
          ))}
        </div>
      </div>

      {/* Floating Elements */}
      <div
        animate={{ rotate: 360 }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
        className="absolute top-20 right-20 w-32 h-32 border border-blue-400 opacity-20 rounded-full"
      />
      <div
        animate={{ rotate: -360 }}
        transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
        className="absolute bottom-20 left-20 w-24 h-24 border border-green-400 opacity-20 rounded-full"
      />
    </section>
  );
};

export default Hero; 